import { IconButton, Label, Pivot, PivotItem } from '@fluentui/react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import * as Api from '../../api/src';
import '../../css/components/test.scss';
import useToken from '../account/login/useToken';
import General from './general';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import AssignedProducts from './assignedProducts';

const TestsApi = new Api.TestsApi();
interface ParamTypes {
  id: string;
}
const TestDetail = () => {
  let { id } = useParams<ParamTypes>();
  let routerHistory = useHistory();
  const { state } = useLocation();
  const {} = useToken();
  const { t } = useTranslation();
  const [detail, SetDetail] = React.useState<Api.TestDto>({ States: Api.StatesEnum.Active });
  React.useEffect(() => {
    getItemData(parseInt(id));
  }, []);
  const getItemData = async (Id?: number) => {
    var data = (await TestsApi.apiTestsIdGet(Id || 0)).data;
    SetDetail(data.Data || { States: Api.StatesEnum.Active });
  };
  return (
    <div className="test test-detail">
      <div className={'page-header flex-center'}>
        <IconButton
          iconProps={{ iconName: 'ChromeBack' }}
          onClick={() => {
            routerHistory.push('/tests');
          }}
        />{' '}
        <Label>{detail.Name}</Label>
      </div>
      <Pivot className="tab-header" style={{ overflowY: 'hidden', overflowX: 'auto' }}>
        <PivotItem headerText={t('General')} itemKey={'General'}>
          <General
            Item={detail}
            RefeshTab={(id) => {
              getItemData(id || 0);
            }}
          ></General>
        </PivotItem>
        <PivotItem headerText={t('Products')} itemKey={'Products'}>
          <AssignedProducts Item={detail}></AssignedProducts>
        </PivotItem>
      </Pivot>
    </div>
  );
};
export default TestDetail;
